import PropositionListViewModel from "../view/propositionlistviewmodel";
import PagedElements from "./pagedelements";

export default class PagedPropositions extends PagedElements<PropositionListViewModel> {
    constructor(init?: Partial<PagedPropositions>) { super(init); }
}